module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/september-d83b475e193ceed1885d5cb390155e46.png";